export class BrakeUsageBar extends Phaser.GameObjects.Container {
  private background: Phaser.GameObjects.Graphics;
  private fillBar: Phaser.GameObjects.Graphics;
  private label: Phaser.GameObjects.BitmapText;

  private barWidth = 20;
  private barHeight = 200;
  private currentUsage = 0;
  private maxUsage = 100;

  constructor(scene: Phaser.Scene) {
    super(scene, 0, 0);

    // Create background
    this.background = new Phaser.GameObjects.Graphics(scene);
    this.add(this.background);

    // Create fill bar
    this.fillBar = new Phaser.GameObjects.Graphics(scene);
    this.add(this.fillBar);

    // Create label
    this.label = new Phaser.GameObjects.BitmapText(
      scene,
      this.barWidth + 10,
      0,
      "fnt_paintBasic",
      "HEAT",
      16,
    ).setOrigin(0.5, 1);
    this.add(this.label);

    this.drawBar();
  }

  /**
   * Update the brake usage percentage (0-100)
   */
  public updateUsage(usage: number): void {
    this.currentUsage = Math.max(0, Math.min(usage, this.maxUsage));
    this.drawBar();
  }

  /**
   * Set the size of the brake bar
   */
  public override setSize(width: number, height: number): this {
    this.barWidth = width;
    this.barHeight = height;
    this.label.setPosition(0, -this.barHeight / 2);
    this.drawBar();
    return this;
  }

  /**
   * Draw the brake usage bar
   */
  private drawBar(): void {
    // Clear previous graphics
    this.background.clear();
    this.fillBar.clear();

    // Draw background (border)
    this.background.lineStyle(2, 0x333333, 1);
    this.background.fillStyle(0x111111, 0.8);
    this.background.fillRoundedRect(
      -this.barWidth / 2,
      -this.barHeight / 2,
      this.barWidth,
      this.barHeight,
      4,
    );
    this.background.strokeRoundedRect(
      -this.barWidth / 2,
      -this.barHeight / 2,
      this.barWidth,
      this.barHeight,
      4,
    );

    // Draw fill based on usage percentage
    if (this.currentUsage > 0) {
      const fillHeight =
        (this.currentUsage / this.maxUsage) * (this.barHeight - 4);

      // Color changes based on usage level
      let fillColor = 0x0b9d5f; // Green
      if (this.currentUsage > 60) {
        fillColor = 0xfa6735; // Orange
      }
      if (this.currentUsage > 80) {
        fillColor = 0xb90e4a; // Red
      }

      this.fillBar.fillStyle(fillColor, 0.8);
      this.fillBar.fillRoundedRect(
        -this.barWidth / 2 + 2,
        this.barHeight / 2 - 2 - fillHeight,
        this.barWidth - 4,
        fillHeight,
        2,
      );
    }

    // Update label color based on brake availability
    if (this.currentUsage >= this.maxUsage) {
      this.label.setTint(0xb90e4a); // Red when brake is exhausted
    } else {
      this.label.setTint(0xffffff); // White when brake is available
    }
  }

  /**
   * Check if brake is exhausted
   */
  public isExhausted(): boolean {
    return this.currentUsage >= this.maxUsage;
  }
}
